import React from "react";
import HoursLogo from "../../assets/headings/hours.svg"
import "./Hours.scss"
import Conceptual from "../../assets/headings/conceptual-hours.svg"
import Debugging from "../../assets/headings/debugging-hours.svg"
import ProjectHours from "../../assets/headings/project-hours.svg"
import { SectionProps } from "../../App";
import { getCourseContent } from "../../data/courseContent";

export class Hours extends React.Component<SectionProps> {
    renderCalendar(src: string, title: string, id?: string) {
        return (
          <div className="iframe-container" id={id} style={{ padding: "0px" }}>
            <iframe
              src={src}
              title={title}
              style={{ border: 0 }}
              width="800"
              height="600"
              frameBorder="0"
              scrolling="no"
            ></iframe>
          </div>
        );
    }

    render() {
        const {
          hoursMode,
          projectHoursCalendar,
          conceptualHoursCalendar,
          debuggingHoursCalendar,
        } = getCourseContent();
        const showProjectHours = hoursMode === "project";

        return (
          <section
            id="hours"
            className={`anchor hours ${this.props.static ? "static" : ""}`}
          >
            <div className="header-container">
              <div className="content-container hours"></div>
              <div className="section-heading">
                <img
                  className="hours-logo logo"
                  src={HoursLogo}
                  alt="hours text"
                />
              </div>
              {showProjectHours ? (
                <>
                  <div className="hours-description">
                    <center>
                      <img
                        className="resources-title-svg"
                        src={ProjectHours}
                        alt="project hours"
                        style={{ margin: "0px" }}
                      />
                    </center>
                    <p style={{ margin: "0px" }}>
                      Confused about your code, and unsure if it is a conceptual
                      misunderstanding or just a setup issue? Project hours are the
                      first phase of our TA hours that are meant to get students
                      comfortable with Java syntax and intro Java concepts for the
                      first few projects so you can build a strong foundation on the
                      basics of CS.
                    </p>
                    <p>
                      Click on the timeslot you are looking to attend in order to
                      see which room it is in!
                    </p>
                  </div>
                  {this.renderCalendar(projectHoursCalendar, "Project hours calendar", "project-hours-calendar")}
                </>
              ) : (
                <>
                  <div className="hours-description">
                    <center>
                      <img
                        className="resources-title-svg"
                        src={Conceptual}
                        alt="conceptual hours"
                        style={{ margin: "0px" }}
                      />
                    </center>
                    <p style={{ margin: "0px" }}>
                      Confused about an idea discussed in lecture or in a project
                      handout? If we don't have to look at your code to answer your
                      question, conceptual hours are a great place to meet other
                      students and talk to a TA. Your question will get answered
                      much faster here than at the debugging hours line. Note that
                      laptops are not allowed in conceptual hours - if you have a
                      specific question about your code, please go to debugging
                      hours. Check out the{" "}
                      <a
                        href="https://docs.google.com/document/d/1wnQ2Fu_7RiMucqU_4BZ5BS8l7F86ndagaLbYYscgA3c/edit?usp=sharing"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        TA Hours Policy here
                      </a>
                      !
                      
                    </p>
                    <p>
                      Click on the timeslot you are looking to attend in order to
                      see which room it is in!
                    </p>
                  </div>
                  {this.renderCalendar(conceptualHoursCalendar, "Conceptual hours calendar")}
                  <div className="hours-description">
                    <center>
                      <img
                        className="resources-title-svg"
                        src={Debugging}
                        alt="debugging hours"
                        style={{ margin: "0px" }}
                      />
                    </center>
                    <p style={{ margin: "0px" }}>
                      Debugging Hours are a great resource to discuss 1-on-1 with a
                      TA about your code and learn how to solve your bugs; however,
                      please be sure to check our TA Hours policy and the Ed page
                      before getting in line at{" "}
                      <a
                        href="https://hours.cs.brown.edu/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        the hours website
                      </a>
                      .
                      When waiting for hours, wait near CIT 210 and a TA will come
                      to get you!
                    </p>
                    <p>
                      Click on the timeslot you are looking to attend in order to
                      see which room it is in!
                    </p>
                  </div>
                  {this.renderCalendar(
                    debuggingHoursCalendar,
                    "Debugging hours calendar",
                    "debugging-hours-calendar"
                  )}
                </>
              )}
            </div>
          </section>
        );
    }
}
